import {
  format,
  isToday,
  isYesterday,
  differenceInCalendarDays,
} from 'date-fns';
import { ptBR } from 'date-fns/locale';

export function formatDate(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  const diff = differenceInCalendarDays(new Date(), d);

  if (isToday(d)) return 'Hoje';
  if (isYesterday(d)) return 'Ontem';

  if (diff <= 6 && diff > 1) {
    return format(d, 'EEEE', { locale: ptBR });
  }

  return format(d, "dd 'de' MMMM 'de' yyyy", { locale: ptBR });
}
